import { MediaTrackingEvent } from '@tracker/mediaTracking/mediaTrackingModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

export const EVENT_TRACKING_DEFAULT_ENDPOINT = '/api/v1/tracked-events';

export const webGatewayTrackEventsFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'web_gateway',
    `${EVENT_TRACKING_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );
};

export const trackMediaEvents = async (
  mediaEvents: MediaTrackingEvent[],
): Promise<void> => {
  await webGatewayTrackEventsFetch('/media', {
    method: 'POST',
    body: serializeMediaEvents(mediaEvents),
  });
};

const serializeMediaEvents = (mediaEvents: MediaTrackingEvent[]): string => {
  return JSON.stringify({
    events: mediaEvents.map((mediaEvent) => {
      if ('otherFields' in mediaEvent) {
        return {
          ...mediaEvent,
          otherFields: JSON.stringify(mediaEvent.otherFields),
        };
      }
      return mediaEvent;
    }),
  });
};
